import { render, staticRenderFns } from "./account-register-check-email.vue?vue&type=template&id=5f4eeddb&scoped=true"
import script from "./account-register-check-email.vue?vue&type=script&lang=js"
export * from "./account-register-check-email.vue?vue&type=script&lang=js"
import style0 from "./account-register-check-email.vue?vue&type=style&index=0&id=5f4eeddb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4eeddb",
  null
  
)

export default component.exports